//
// Load jQuery plugins
//
// import 'bootstrap';
import 'arrive';
import 'bootstrap';
import 'aos';


//
//  Load custom js
//
import theme from './_theme';

//
//  Misc
//
import scroll from './misc/_scroll';

//
//  Blockss
//

// import sliderIcon from './blocks/_slider-icon-text-cta';
// import gallerySlider from './blocks/_gallery-masonry';
// import counters from './blocks/_counters';
import background_scroll_parallax from './blocks/_background-scroll-parallax';
import navbar from './blocks/_navbar';
import hero_background from './blocks/_hero-background';
import steps from './blocks/_steps';
import hero_video_parallax from './blocks/_hero-parallax-video';
import footer from './blocks/_footer';